import GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModelBase from '../_generated/modelBases/get-organisation-by-external-id-and-event-identifier-async-request-model-base';

export default class GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModel extends GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
